import React from "react";
import "../styles/Globalbranchescarousel.css";

import netherlandsImg from "../pictures/the_netherlands.avif";
import germanyImg from "../pictures/the_germans.jpg";
import uaeImg from "../pictures/ramadan-market.jpg";

// Translation object
const translations = {
  en: {
    globalNetwork: "GLOBAL NETWORK",
    discoverBranches: "Discover Our Branches",
    premiumFlooring:
      "Premium flooring solutions delivered globally with innovation, elegance and craftsmanship.",
    internationalBranch: "INTERNATIONAL BRANCH",
    netherlands: "Netherlands",
    germany: "Germany",
    uae: "United Arab Emirates",
    mattFactoryNL: "Indo-Euro Rubber Solutions",
    addressNL: "Netherlands",
    mattFactoryDE: "Indo-Euro Rubber Solutions",
    addressDE: "Müllerstr. 30, 12207 Berlin, Germany",
    mattFactoryAE: "Landlord General Maintenance LLC",
    addressAE: "P. O. Box 35818, Abu Dhabi, UAE",
  },
  de: {
    globalNetwork: "GLOBALES NETZWERK",
    discoverBranches: "Entdecken Sie Unsere Niederlassungen",
    premiumFlooring:
      "Premium-Bodenlösungen weltweit mit Innovation, Eleganz und Handwerkskunst.",
    internationalBranch: "INTERNATIONALE FILIALE",
    netherlands: "Niederlande",
    germany: "Deutschland",
    uae: "Vereinigte Arabische Emirate",
    mattFactoryNL: "Indo-Euro Rubber Solutions",
    addressNL: "Niederlande",
    mattFactoryDE: "Indo-Euro Rubber Solutions",
    addressDE: "Müllerstr. 30, 12207 Berlin, Deutschland",
    mattFactoryAE: "Landlord General Maintenance LLC",
    addressAE: "P. O. Box 35818, Abu Dhabi, VAE",
  },
  nl: {
    globalNetwork: "WERELDWIJD NETWERK",
    discoverBranches: "Ontdek Onze Filialen",
    premiumFlooring:
      "Premium vloeroplossingen wereldwijd met innovatie, elegantie en vakmanschap.",
    internationalBranch: "INTERNATIONALE VESTIGING",
    netherlands: "Nederland",
    germany: "Duitsland",
    uae: "Verenigde Arabische Emiraten",
    mattFactoryNL: "Indo-Euro Rubber Solutions",
    addressNL: "Nederland",
    mattFactoryDE: "Indo-Euro Rubber Solutions",
    addressDE: "Müllerstr. 30, 12207 Berlin, Duitsland",
    mattFactoryAE: "Landlord General Maintenance LLC",
    addressAE: "P. O. Box 35818, Abu Dhabi, VAE",
  },
  ar: {
    globalNetwork: "الشبكة العالمية",
    discoverBranches: "اكتشف فروعنا",
    premiumFlooring:
      "حلول أرضيات فاخرة يتم تسليمها عالميًا بالابتكار والأناقة والحرفية.",
    internationalBranch: "فرع دولي",
    netherlands: "هولندا",
    germany: "ألمانيا",
    uae: "الإمارات العربية المتحدة",
    mattFactoryNL: "Indo-Euro Rubber Solutions",
    addressNL: "هولندا",
    mattFactoryDE: "Indo-Euro Rubber Solutions",
    addressDE: "Müllerstr. 30, 12207 برلين، ألمانيا",
    mattFactoryAE: "Landlord General Maintenance LLC",
    addressAE: "صندوق بريد 35818، أبو ظبي، الإمارات العربية المتحدة",
  },
};

function Globalbranchescarousel({ language = "en" }) {
  // Get the correct translation object with fallback
  const t = translations[language] || translations.en;

  const branches = [
    {
      countryKey: "netherlands",
      companyKey: "mattFactoryNL",
      addressKey: "addressNL",
      image: netherlandsImg,
    },
    {
      countryKey: "germany",
      companyKey: "mattFactoryDE",
      addressKey: "addressDE",
      image: germanyImg,
    },
    {
      countryKey: "uae",
      companyKey: "mattFactoryAE",
      addressKey: "addressAE",
      image: uaeImg,
    },
  ];

  return (
    <section className="branches-wrapper" dir={language === "ar" ? "rtl" : "ltr"}>
      <div className="branches-header">
        <span className="branches-eyebrow">{t.globalNetwork || "GLOBAL NETWORK"}</span>

        <h1 className="branches-heading">{t.discoverBranches || "Discover Our Branches"}</h1>

        <p className="branches-subtext">{t.premiumFlooring || "Premium flooring solutions delivered globally"}</p>
      </div>

      <div className="branches-grid">
        {branches.map((branch, index) => (
          <div
            key={index}
            className="branches-card"
          >
            <img
              src={branch.image}
              alt={t[branch.countryKey] || "Branch"}
              className="branches-image"
            />

            <div className="branches-overlay"></div>

            <div className="branches-content">
              <span className="branches-tag">{t.internationalBranch || "INTERNATIONAL BRANCH"}</span>

              <h2>{t[branch.countryKey] || "Branch"}</h2>

              <div className="branches-line"></div>

              <p className="branches-company">{t[branch.companyKey] || "Company"}</p>

              <p className="branches-address">{t[branch.addressKey] || "Address"}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}

export default Globalbranchescarousel;